export interface ISegmentAPI {
  track(eventName: string, props?: object): void;
  identify(userIdentifier: string | number, props?: object): void;
  group(entityIdentifier: string, props?: object): void;
  resetIdentityTraits(): void;
  page(pageName: string, props?: object): void;
}

const devMock =
  process.env.NODE_ENV === 'development'
    ? (...bindArgs) =>
        (...args) =>
          // eslint-disable-next-line no-console
          console.log(...bindArgs.concat(args).filter((x) => x != null))
    : (function () {
        // it has to be a function expression and not an arrow function because `.bind` may be called on it
        return () => {};
      } as any);

export const DevMockSegmentAnalytics: ISegmentAPI = {
  track: devMock(null, 'segment:track'),
  identify: devMock(null, 'segment:identify'),
  group: devMock(null, 'segment:group'),
  resetIdentityTraits: devMock(null, 'segment:resetIdentify'),
  page: devMock(null, 'segment:page')
};

export const SegmentAnalyticsAccessor = {
  identify(userIdentifier: string | number, props?: object): void {
    (window as any).analytics.identify(userIdentifier, props);
  },
  group(entityIdentifier: string, props?: object): void {
    (window as any).analytics.group(entityIdentifier, props);
  },
  track(eventName: string, props?: object): void {
    (window as any).analytics.track(eventName, props);
  },
  page(pageName: string, props?: object): void {
    (window as any).analytics.page({ name: pageName, type: 'page', properties: props });
  },
  resetIdentityTraits(): void {
    (window as any).analytics.reset();
  }
};

export const SegmentWrapper = !(window as any).analytics ? DevMockSegmentAnalytics : SegmentAnalyticsAccessor;
